import { Object, String, Static, Optional, Array, Boolean, Composite, Record } from '@sinclair/typebox';

import { BoundFlight } from '../../flightOffers';

const dateSchema = String({
  description: 'ISO 8601 date-time format with optional positive or negative time offset',
  title: 'Date-Time with Timezone Offset',
  examples: ['2024-10-19T10:50:00+02:00', '2024-10-19T10:50:00-02:00'],
});

// TODO: split up types for different services, e.g. swagger will lie otherwise
export const SelfReaccommodationFlightsQueryParams = Object({
  pnr: String(),
  lastName: String(),
  alternativeOutboundId: Optional(String()),
  alternativeInboundId: Optional(String()),
  outboundDate: Optional(dateSchema),
  inboundDate: Optional(dateSchema),
  outboundReservationDate: Optional(dateSchema),
  inboundReservationDate: Optional(dateSchema),
  reservationId: Optional(String()),
  isOutboundInIrropsWindow: Optional(Boolean()),
  isInboundInIrropsWindow: Optional(Boolean()),
  offerId: Optional(String()),
  isOutboundDisrupted: Optional(Boolean()),
  isInboundDisrupted: Optional(Boolean()),
});
export type SelfReaccommodationFlightsQueryParams = Static<typeof SelfReaccommodationFlightsQueryParams>;

export const SelfReaccommodationTab = Object({ date: String(), isSelectable: Boolean() });
export type SelfReaccommodationTab = Static<typeof SelfReaccommodationTab>;

export const AlternativeFlightsResponse = Object({
  offerId: String(),
  outboundFlights: Optional(Array(BoundFlight)),
  inboundFlights: Optional(Array(BoundFlight)),
});
export type AlternativeFlightsResponse = Static<typeof AlternativeFlightsResponse>;

export const BoundFlightCacheResponse = Object({
  tabs: Optional(Array(SelfReaccommodationTab)),
  flights: Optional(Record(String(), Optional(Array(BoundFlight)))),
});
export type BoundFlightCacheResponse = Static<typeof BoundFlightCacheResponse>;

export const AlternativeFlightsCacheResponse = Object({
  offerId: String(),
  outbound: Object({
    isUserInIrropsWindow: Boolean(),
    boundFlightCacheResponse: BoundFlightCacheResponse,
  }),
  inbound: Object({
    isUserInIrropsWindow: Boolean(),
    boundFlightCacheResponse: BoundFlightCacheResponse,
  }),
});
export type AlternativeFlightsCacheResponse = Static<typeof AlternativeFlightsCacheResponse>;

export const SelfReaccommodationFlightsResponse = Composite([
  AlternativeFlightsResponse,
  Object({
    upsellTable: Object({
      tabs: Object({
        outbound: Optional(Array(SelfReaccommodationTab)),
        inbound: Optional(Array(SelfReaccommodationTab)),
      }),
    }),
  }),
]);
export type SelfReaccommodationFlightsResponse = Static<typeof SelfReaccommodationFlightsResponse>;
